export default __webpack_public_path__ + "static/media/Product-syndication.e8d0f70d.svg";